module.exports = __webpack_public_path__ + "static/media/linkedin-icon.d5a50b62.svg";